module.exports = __webpack_public_path__ + "assets/school-graduation.a5033441b81d510882bc55c574859ab1.svg";